import React from "react";
import { Shapes } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { StateBadge } from "./AdminLayout";
import { apiGet, apiPost, apiPut } from "./adminApi";

const fields = [
  { name: "combinationCode", label: "Combination Code", type: "text", required: true, placeholder: "e.g. MPC" },
  { name: "combinationName", label: "Combination Name", type: "text", required: true, placeholder: "e.g. Mathematics-Physics-Computer Science" },
];

export default function CombinationsPage() {
  return (
    <AdminCrudPage
      title="Combinations"
      subtitle="Secondary school subject combinations used on bursary applications"
      icon={Shapes}
      entityName="combination"
      queryKey="adminCombinations"
      fetchAll={() => apiGet("hec/combination/admin/all")}
      createItem={(values) => apiPost("hec/combination/admin/create", values)}
      updateItem={(id, values, row) => apiPut(`hec/combination/admin/${id}`, { ...values, state: row.state })}
      searchKeys={["combinationCode", "combinationName"]}
      columns={[
        { key: "combinationCode", label: "Code", render: (r) => <span className="font-mono text-gray-700">{r.combinationCode}</span> },
        { key: "combinationName", label: "Combination", render: (r) => <span className="font-semibold text-gray-900">{r.combinationName}</span> },
        { key: "state", label: "Status", render: (r) => <StateBadge state={r.state} /> },
      ]}
      fields={fields}
    />
  );
}
